export default "__VITE_ASSET__B6SD0Jt3__"